import { Component, OnInit, AfterContentInit, ViewChild, ElementRef } from '@angular/core';
import { FuncionalidadeService } from '../../../services/funcionalidade.service';
import { UsuarioService } from '../../../services/usuario.service';
import { Funcionalidade } from '../../../models/funcionalidade.model';
import { Autorizacao } from '../../../models/Autorizacao.model';
import { UsuarioCadastrado } from '../../../models/usuario-cadastrado.model';
import { Usuario } from '../../../models/usuario.model';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Security } from 'src/app/utils/security.util';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';

@Component({
  selector: 'app-usuario-page',
  templateUrl: './usuario-page.component.html',
  styleUrls: ['./usuario-page.component.scss'],
  providers: [FuncionalidadeService, UsuarioService]

})
export class UsuarioPageComponent implements OnInit, AfterContentInit {


  constructor(
    private funcionalidadeService: FuncionalidadeService,
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
  ) { }


  tipoAutorizacoes: string[] = ['Acessar', 'Incluir/Salvar/Executar', 'Excluir',
    'Alterar/Editar', 'Listar/Pesquisar/Imprimir', 'Autorizado'];
  possiveisNiveisDeAcesso: string[] = ['Solicitante', 'Gestor', 'Administrativo'];
  paletaDeCoresFundo = ['#d3edf8', '#57adc3', '#007795', '#146a7b']; // na grid altera a cor do fundo nos títulos dos níveis
  paletaDeCoresFonte = ['#286090', '#fff', '#fff', '#fff'];
  marcarDesmarcarTodos: boolean[] = [false, false, false, false, false, false];



  niveisDeAcesso: string[] = []; // Mantém um subconjunto dos possíveis níves de acesso
  autorizacoes: Autorizacao[] = []; // Armazena o conjunto de autorizações concedidas ao usuário
  usuario: Usuario = null; // usuário selecionado, se for o caso
  arrayFuncionalidades: Array<Funcionalidade[]> = []; // array de array de funcionalidades. Um array de funcionalidade para cada nível
  cadastrados: UsuarioCadastrado[] = []; // lista de usuários já cadastrados, exibidos em grid
  usuarioConsultadoId = 0;
  nivelUsuarioLogado = 1;
  usuarioAtivo = true;
  usuarioLogadoId = 0;


  fotoBase64: any = null;
  fotoMimeType = '';


  modoInsercao = true;
  isSalvando = false;
  animate = false;


  form: FormGroup;

  usuarioAutorizacoes: UsuarioAutorizacoes;

  maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  @ViewChild('inputSearchNomeLogin') inputSearchNomeLogin: ElementRef;

  searchLoading:boolean = false;



  ngAfterContentInit(): void {
    if (this.nivelUsuarioLogado < 5) {
      this.usuarioAutorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('usuario');
    } else {
      this.usuarioAutorizacoes = new UsuarioAutorizacoes(0, true, 'usuario', '', 5, 0, true, true, true, true, true, true, 0, '');
    }
  }

  ngOnInit() {
    this.resetForm();
    this.getFuncionalidadesNivelUsuarios(1);
    this.getUsuariosCadastrados();
    this.nivelUsuarioLogado = Security.getUser().nivel;
    this.usuarioLogadoId = this.usuarioService.getUsuarioLogadoId();
  }


  resetForm() {
    this.form = this.formBuilder.group({
      id: new FormControl(''),
      foto: new FormControl(null),
      fotoMimeType: new FormControl(''),
      nome: new FormControl('', Validators.required),
      login: new FormControl('', Validators.required),
      email: new FormControl('', Validators.email),
      telefone: new FormControl(''),
      nivel: new FormControl(1),
      autorizacoes: [],
      tipoAcesso: new FormControl(3),
      codigoDispositivo: new FormControl('')
    }
    );
  }


  getTipoAcessoUsuario(tipoAcesso: number) {
    this.form.controls.tipoAcesso.setValue(tipoAcesso);
  }

  getFuncionalidadesNivelUsuarios(nivel: number) {

    this.form.get('nivel').setValue(nivel);

    this.arrayFuncionalidades = []; // agrupa as funcionalidades por nível, cada nível é um array delas
    this.niveisDeAcesso = []; // limita os níveis de acesso a serem exibidos

    this.funcionalidadeService.getFuncionalidadesNivelUsuarios(nivel, this.usuarioConsultadoId).subscribe(response => {
      if (this.usuarioConsultadoId > 0) {
        this.autorizacoes = [];
      }

      this.possiveisNiveisDeAcesso.forEach((n, i) => {
        if (i < nivel) { this.niveisDeAcesso.push(n); }
      });

      for (let i = 1; i <= nivel; i++) {
        this.arrayFuncionalidades.push(response.filter(f => f.nivel === i));
      }
      /* Adiciona todas as autorizações do usuário consultado */
      if (this.usuarioConsultadoId > 0) {

        response.forEach(f => {
          const aut = new Autorizacao(f.uPodeAcessar, f.uPodeIncluir, f.uPodeExcluir,
            f.uPodeAlterar, f.uPodeListar, f.uEstaAutorizado, f.funcionalidadeId);

          if (!aut.hasNenhumaAutorizacao()) {
            this.autorizacoes.push(aut);
          }
        });
      }
      this.animate = true;
    },
      (err: any) => {
        this.toastr.error('Erro ao tentar obter as funcionalidades no níve do usuário');
      });

  }

  /* Método acionado ao marcar/desmarcar uma autorização na grid */
  marcaDesmarcaAutorizacao(funcionalidadeId: number, tipoAut: number, valor: boolean, f: Funcionalidade) {


    if (this.nivelUsuarioLogado < 5) {

      const usuarioLogadoTemAutorizacaoSolicitada = this.getUsuarioLogadoTemAutorizacaoSolicitada(tipoAut, f);

      if (usuarioLogadoTemAutorizacaoSolicitada === false) {
        return;
      }
    }

    const usuarioId = this.form.get('id').value === '' ? 0 : this.form.get('id').value;

    /* tipoAut: 0 - PodeAcessar, 1 - PodeIncluir, 2 - PodeExcluir, 3 - PodeAlterar, 4 - PodeListar, 5 - EstaAutorizado  */

    /* Verifica se já há uma autorização para a funcionalidade em questão */
    const aut = this.autorizacoes.find(a => a.funcionalidadeId === funcionalidadeId);

    if (aut === undefined) {
      // primeira autorização da funcionalidade em questão, uma nova autorização é adicionada a lista de autorizações para o usuário
      this.autorizacoes.push(new Autorizacao(tipoAut === 0, tipoAut === 1, tipoAut === 2,
        tipoAut === 3, tipoAut === 4, tipoAut === 5, funcionalidadeId));

    } else {
      // edição de uma autorização existente
      aut.marcaDesmarcaAutorizacao(tipoAut, valor);
    }

    this.marcaDesmarcaAutorizacaoFuncionalidade(tipoAut, valor, f);

    if (aut !== undefined) {
      if (aut.hasNenhumaAutorizacao()) {

        // remove da lista a autorização onde nenhum tipo de autorização esta marcada
        this.autorizacoes = this.autorizacoes.filter(a => a.funcionalidadeId !== aut.funcionalidadeId);
      }
    }
  }

  getCheckedAutorizacao(funcionalidadeId: number, indiceAut: number): boolean {

    const aut = this.autorizacoes.find(a => a.funcionalidadeId === funcionalidadeId);

    // nenhumm usuario selecionado
    if (aut === undefined) {
      return false;
    } else {
      return aut.getAutorizacao(indiceAut);
    }
  }

  setMarcarDesmarcarTodos(indice: number, value: boolean) {
    this.marcarDesmarcarTodos[indice] = value;

    this.arrayFuncionalidades.forEach(af => {
      af.forEach(f => {
        this.marcaDesmarcaAutorizacao(f.funcionalidadeId, indice, value, f);
      });
    });

  }

  getUsuariosCadastrados(): void {
    this.cadastrados = [];
    this.usuarioService.getUsuariosCadastrados().subscribe((response) => { this.cadastrados = response; },
      (err: any) => {
        this.toastr.error('Erro ao tentar obter Usuarios Cadastrados');
      });
  }

  public getSantizeUrl(fotoMimeType: string, foto: string) {
    const url = `data:${fotoMimeType};base64, ${foto}`;
    return this.usuarioService.bypassSecurityTrustUrl(url);
  }

  /* Obtem do banco, o usuário cadastrado que foi selecionado na grid */
  getUsuario(id: number, ativo: boolean) {

    this.usuarioService.getUsuario(id).subscribe((response) => {

      this.usuarioConsultadoId = response.id;
      this.getFuncionalidadesNivelUsuarios(response.nivel);
      this.modoInsercao = false; // Edição
      this.usuarioAtivo = ativo;

      this.form.setValue(
        {
          id: response.id,
          foto: response.foto,
          fotoMimeType: response.fotoMimeType,
          nome: response.nome,
          login: response.login,
          email: response.email,
          telefone: response.telefone,
          nivel: response.nivel,
          autorizacoes: [],
          tipoAcesso: response.tipoAcesso,
          codigoDispositivo: response.codigoDispositivo
        });


      if (response.foto != null && response.foto !== '') {
        // apresenta a foto na box de foto
        this.fotoBase64 = this.usuarioService.getSantizeUrl(response.fotoMimeType, response.foto);
      } else {
        this.fotoBase64 = null; // no-image
      }

    },
      (err: any) => {
        this.toastr.error('Erro ao tentar obter o Usuario');
      });
  }

  resetSearch(): void {
    this.inputSearchNomeLogin.nativeElement.value = "";
    this.getUsuariosCadastrados();
  }


  reset(recarregarCadastrados: boolean = false): void {

    this.resetForm();
    this.usuarioConsultadoId = 0;
    this.niveisDeAcesso = [];
    this.autorizacoes = [];
    this.arrayFuncionalidades = [];
    this.modoInsercao = true; // indica se usuário esta cadastrando novo item
    this.isSalvando = false;
    this.fotoMimeType = '';

    this.fotoBase64 = null;
    this.getFuncionalidadesNivelUsuarios(1);
    //this.getUsuariosCadastrados();
    window.scrollTo({ top: 0, behavior: 'smooth' });


    if (recarregarCadastrados) {
      this.inputSearchNomeLogin.nativeElement.value = "";
      this.getUsuariosCadastrados();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }






  }

  upload(file: any) {

    // necessario para upload via IformFile
    this.fotoMimeType = file[0].type;

    // necessario para upload via base64
    const reader = new FileReader();
    reader.onload = this.manipularReader.bind(this);
    reader.readAsBinaryString(file[0]);
  }

  manipularReader(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.fotoBase64 = btoa(binaryString);
    this.form.get('foto').setValue(this.fotoBase64);
    this.form.get('fotoMimeType').setValue(this.fotoMimeType);

    const url = `data:${this.fotoMimeType};base64, ${this.fotoBase64}`;
    this.fotoBase64 = this.usuarioService.bypassSecurityTrustUrl(url);
  }


  submit() {

    this.isSalvando = true;
    this.form.get('autorizacoes').setValue(this.autorizacoes);

    if (this.modoInsercao) {
      this.cadastrar();
    } else {
      this.editar();
    }
  }


  // Métodos privates

  private cadastrar() {

    this.form.get('id').setValue(0);

    this.usuarioService
      .registrar(this.form.value)
      .subscribe(
        (data: any) => {
          this.toastr.success(data.message);
          this.reset(true);
        },
        (err) => {

          if (err.error.errors) {
            this.toastr.error(err.error.errors[0].message);
          } else {
            this.toastr.error('Ocorreu um erro no servidor');
          }
        },
      );
  }


  private editar() {

    const id = this.form.get('id').value;

    this.usuarioService
      .editar(Number(id), this.form.value)
      .subscribe(
        (data: any) => {
          this.toastr.success(data.message);
          this.reset();
        },
        (err) => {
          if (err.error.errors) {
            this.toastr.error(err.error.errors[0].message);
          } else {
            this.toastr.error('Ocorreu um erro no servidor');
          }
        },
      );
  }

  public resetarSenhaUsuario() {

    if (this.usuarioConsultadoId > 0) {
      this.usuarioService.resertarSenha(this.usuarioConsultadoId).subscribe((response) => {
        this.toastr.success('Senha resetada com sucesso');
        this.reset();
      },
        (err: any) => {
          this.toastr.error('Não foi possível resetar a senha');
        });
    }
  }


  public ativarDesativarUsuario() {

    if (this.usuarioConsultadoId > 0) {
      this.usuarioService.ativarDesativar(this.usuarioConsultadoId).subscribe((data: any) => {

        if (data.mensagem === 'ativado') {
          this.toastr.success(`Usuario ativado com Sucesso`);
        } else {
          this.toastr.success(`Usuario desativado com Sucesso`);
        }

        this.reset(true);
      },
        (err: any) => {
          this.toastr.error('Não foi possível ativer/desativar usuário');
        });
    }
  }

  getUsuarioLogadoTemAutorizacaoSolicitada(tipoAut: number, f: Funcionalidade) {
    switch (tipoAut) {
      case 0:
        return f.ulPodeAcessar === true;
      case 1:
        return f.ulPodeIncluir === true;
      case 2:
        return f.ulPodeExcluir === true;
      case 3:
        return f.ulPodeAlterar === true;
      case 4:
        return f.ulPodeListar === true;
      case 5:
        return f.ulEstaAutorizado === true;
    }
  }

  marcaDesmarcaAutorizacaoFuncionalidade(tipoAut: number, valor: boolean, f: Funcionalidade) {
    switch (tipoAut) {
      case 0:
        f.uPodeAcessar = valor;
        break;
      case 1:
        f.uPodeIncluir = valor;
        break;
      case 2:
        f.uPodeExcluir = valor;
        break;
      case 3:
        f.uPodeAlterar = valor;
        break;
      case 4:
        f.uPodeListar = valor;
        break;
      case 5:
        f.uEstaAutorizado = valor;
    }
  }


  getUsuarioPorNomeLogin(nomeLogin: string) {

    if (nomeLogin == "") {
      //this.reset(true);
      return;
    }

    this.searchLoading = true;
    this.cadastrados = [];
    this.usuarioService.getUsuarioCadastradoPorNomeLogin(nomeLogin).subscribe(
      (response: UsuarioCadastrado[]) => {
        //this.reset();
        this.cadastrados = response;
        this.searchLoading = false;
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.searchLoading = false
      },
    );

  }


  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }



}
